<template>
    <div class='endorsed-modal' v-show="isOpen" style="display: block;">
        <div class='endorsed-modal-shade' @click="this.closeModal"></div>
        <div class='endorsed-modal-inner'>
            <div class='endorsed-modal-header'>
                <svg class='check'><use xlink:href="#check"></use></svg> Members
                <span class='endorsed-modal-close' @click="this.closeModal">
                    <svg class='close'><use xlink:href="#close"></use></svg>
                </span>
            </div>
            <div class='endorsed-modal-list'>
                <a :href="`/${member.username}`" :key="i" v-for="(member, i) in members">
                    <img :src="member.profile_thumbnail" data-rjs="2">
                    {{ member.first_name }} {{ member.last_name }}
                    <svg class='verified-badge' aria-labelledby="badgeTitle">
                            <title id="badgeTitle">Well Traveled Insider</title>
                            <use xlink:href="#verified-badge"><title id="badgeTitle">Well Traveled Insider</title></use>
                        </svg>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['isOpen', 'members'],
        methods: {
            closeModal() {
                eventBus.$emit('toggleModal', null);
            }
        }
    }
</script>
